import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'Connection between an innovation asset and an offering',
    name: 'Innovation Asset Offering',
    partialId: PartialId.Standard.create('innovation_asset_offering'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
